import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

interface LineProps {
  data: Array<{ value: number }>;
  stroke: string;
  strokeWidth?: number;
  height?: string;
  type?: 'monotone' | 'linear' | 'step' | 'stepBefore' | 'stepAfter';
}

const LineChartComponent: React.FC<LineProps> = ({
  data,
  stroke,
  strokeWidth = 2,
  height = '100%',
  type = 'monotone'
}) => {
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <Line type={type} dataKey="value" stroke={stroke} strokeWidth={strokeWidth} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;
